import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { ProjectCreationInitializedMessage } from '@app/catalog';

@PresenterType(
{
    model: ProjectCreationInitializedMessage
})
@Component({
  selector: 'project-creation-initialized-message',
  standalone: false,
  template: '<span class="message">{{ data().name }} creation has been initialized successfully.</span>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCreationInitializedMessageComponent {
    public data: WritableSignal<ProjectCreationInitializedMessage>;
    
    constructor() {
        this.data = signal<ProjectCreationInitializedMessage>(null);
    }
}